import { render, staticRenderFns } from "./ProductEditGroup.vue?vue&type=template&id=d1c00014"
import script from "./ProductEditGroup.vue?vue&type=script&lang=js"
export * from "./ProductEditGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports